import { observable, computed, action, makeObservable } from 'mobx'
import Collection from '../Collections/Collection'
import PhaseAggregateModel from './PhaseAggregateModel'
import Aggregate from './Aggregate'

class PhaseAggregate extends Aggregate {
    constructor() {
        super({ collectionClass: PhaseAggregateCollection })
        makeObservable(this)
    }
}

class PhaseAggregateCollection extends Collection {
    constructor() {
        super({
            collection: 'phases',
            modelClass: PhaseAggregateModel,
        })
        this.addLookup('phasesByProjectId', 'manyByKey', {
            key: (t) => t.projectId,
            filter: (t) => !t.deletedAt,
        })
        this.addLookup('phasesByCostCentreId', 'manyByKey', {
            key: (t) => t.phasesByCostCentreId,
            filter: (t) => !t.deletedAt,
        })

        makeObservable(this)
    }
    get phasesById() {
        return this.modelsById
    }
    get phases() {
        return this.models
    }
    get phasesById() {
        return this.modelsById
    }
    @action.bound
    addPhase(data) {
        this.add(data)
    }
    @action.bound
    addPhases(data) {
        this.addMany(data)
    }
}

export default new PhaseAggregate()
export const PhaseAggregateCollectionClass = PhaseAggregateCollection
